import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-dataflow-04',
  standalone: true,
  templateUrl: './rt-icon-dataflow-04.component.html',
  styleUrls: ['./rt-icon-dataflow-04.component.scss']
})
export class RtIconDataflow04Component {
  @Input() width: number | string = 17;
  @Input() height: number | string = 17;
}
